import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import roleAccessService from "../../../components/Services/roleAccess.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";

export default function RoleBasedApiPermissions({
 selectedData,
 handleUserPermissionsModal,
 getAllCompanyAdminUsers,
}) {
 const [data, setData] = useState(selectedData?.role?.permissions);

 const handleSelectedPermissionChange = (permissionIndex) => (event) => {
  setData((prevData) => {
   const newData = [...prevData];
   newData[permissionIndex] = {
    ...newData[permissionIndex],
    checked: event.target.checked,
   };
   return newData;
  });
 };
 const submitUserPermissions = () => {
  let reqBody = [
   {
    userId: selectedData?.userId,
    roleId: selectedData?.role?.id,
    role: selectedData?.role?.role,
    permissions: data,
   },
  ];
  roleAccessService
   .modifyRoleAccess(reqBody)
   .then((response) => {
    if (response?.data?.code === 200) {
     getAllCompanyAdminUsers();
     handleUserPermissionsModal();
     toast.success(response?.data?.message, toastProperties);
    }
   })
   .catch((err) => console.log("Api Call Error: ", err));
 };
 return (
  <div style={{ gap: "20px" }} className="table-scrollY">
   {selectedData &&
    data?.length > 0 &&
    data?.map((item, i) => (
     <div key={i}>
      <FormControlLabel
       label={item.permission}
       control={
        <Checkbox
         checked={item.checked}
         onChange={handleSelectedPermissionChange(i)}
        />
       }
      />
     </div>
    ))}
   <div className="company-profile-btn-group justify-content-center my-4">
    <button
     type="button"
     className="btn btn-login"
     onClick={submitUserPermissions}
    >
     Submit
    </button>
   </div>
  </div>
 );
}
